<div>
  <div
    *ngIf="showDragControls()"
    id="ptzOverlay"
    [class.crosshairCursor]="isCrosshairEnabled"
    (contextmenu)="handleRightClicks($event)"
    (mousedown)="startAreaZoomDrawing($event)"
    (click)="centerOnClick($event)"
    (mousewheel)="onScrollZoom($event)"
  >
    <div
      *ngIf="
        !!fullscreen &&
        playerState === 'playing' &&
        isMovePTZAllowed &&
        !ptzConfig?.ptzControlEnableArrows
      "
      class="crosshairBoundary"
      [class.seeThrough]="isCrosshairEnabled || isAreaZoomDrawing"
      (mouseenter)="showCanvas()"
      (mouseleave)="hideCanvas()"
    ></div>

    <div class="movingPrompt" *ngIf="isDragging">
      <span>
        {{ 'cameras.ptz.moving' | t }}<span class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span>
      </span>
    </div>
    <svg id="areaZoomSvg" width="100%" height="100%"></svg>
    <canvas
      [class.ptzCrosshairOff]="!togglePtz || ptzConfig?.ptzControlEnableArrows"
      [class.seeThrough]="(togglePtz && isCrosshairEnabled) || isAreaZoomDrawing"
      [class.hideCrosshair]="!fullscreen"
      (mousedown)="startDrawing($event)"
      (mouseup)="stopDrawing()"
      (mouseenter)="showCanvas()"
      (mouseleave)="hideCanvas()"
      id="ptzCrosshair"
      width="80"
      height="80"
    ></canvas>
    <svg
      *ngIf="togglePtz && isCrosshairEnabled"
      class="shapeCanvas"
      [class.seeThrough]="isAreaZoomDrawing"
      (mousemove)="keepDrawing($event)"
      (mouseup)="stopDrawing()"
      (mouseleave)="stopDrawing()"
    >
      <ng-container *ngFor="let line of linesToDraw">
        <line
          class="shape"
          *ngIf="line.type === 'line'"
          [attr.x1]="line.x"
          [attr.y1]="line.y"
          [attr.x2]="line.x * 1 + line.w * 1"
          [attr.y2]="line.y * 1 + line.h * 1"
        ></line>
      </ng-container>
    </svg>
  </div>
  <sn-icon-button
    *ngIf="allowPTZ()"
    class="ptz-toggle"
    (click)="ptzToggle()"
    [matTooltip]="'cameras.ptz.togglePtzControls' | t"
    matTooltipPosition="above"
  >
    <sn-icon *ngIf="!togglePtz" size="md">toggle_off</sn-icon>
    <sn-icon *ngIf="togglePtz" size="md" class="yellow-text">toggle_on</sn-icon>
    <small class="ptzText">&nbsp;PTZ</small>
  </sn-icon-button>

  <div class="speedSlider" *ngIf="allowPTZ() && isContinuousMovement()">
    <sn-icon class="fa-solid fa-circle-minus speedSliderIcon"></sn-icon>
    <mat-slider
      [min]="1"
      [max]="10"
      [thumbLabel]="true"
      [matTooltip]="'cameras.ptz.increaseDecreaseSpeed' | t"
      matTooltipPosition="above"
      color="accent"
      (change)="onContinuousMovementSpeedChange($event)"
      [(value)]="ptzModifier"
      [displayWith]="getSliderLabel"
      [step]="0.5"
    ></mat-slider>
    <sn-icon class="fa-solid fa-circle-plus speedSliderIcon"></sn-icon>
  </div>

  <div
    class="ptzControl"
    [class.seeThrough]="isCrosshairEnabled || isAreaZoomDrawing"
    *ngIf="allowPTZ() && togglePtz"
  >
    <sn-icon-button
      *ngIf="!ptzConfig.isCanon && !isPtzControlZoomOnly && isMovePTZAllowed"
      [matTooltip]="'cameras.ptz.presets' | t"
      matTooltipPosition="above"
      [class.green]="isOpen"
      (click)="openPresetsMenu()"
    >
      <sn-icon size="md">wysiwyg</sn-icon>
    </sn-icon-button>
    <sn-icon-button
      *ngIf="isMovePTZAllowed"
      class="ptz-zoom-out"
      (click)="zoomOut()"
      [matTooltip]="'common.zoomOut' | t"
      matTooltipPosition="above"
    >
      <sn-icon size="md">remove</sn-icon>
    </sn-icon-button>
    <sn-icon-button
      *ngIf="isPtzControlZoomOnly || isMovePTZAllowed"
      class="ptz-zoom-in"
      (click)="zoomIn()"
      [matTooltip]="'common.zoomIn' | t"
      matTooltipPosition="above"
    >
      <sn-icon size="md">add</sn-icon>
    </sn-icon-button>
    <sn-icon
      *ngIf="
        isAxis ||
        isSony ||
        isHanwha ||
        (isBosch && !isPtzControlZoomOnly) ||
        (isExternalPtz && ptzConfig?.external?.externalType?.toLowerCase() === 'avigilon')
      "
      class="ptzInstructions"
      [matTooltip]="'cameras.ptz.leftClickToCenter' | t"
      matTooltipPosition="above"
      size="md"
    >
      flare
    </sn-icon>
    <sn-icon
      *ngIf="
        isAxis ||
        isSony ||
        isHanwha ||
        isBosch ||
        (isExternalPtz && ptzConfig?.external?.externalType?.toLowerCase() === 'avigilon')
      "
      class="ptzInstructions"
      [matTooltip]="'cameras.ptz.rightClickAreaZoom' | t"
      matTooltipPosition="above"
      size="md"
    >
      crop
    </sn-icon>
    <sn-icon
      *ngIf="
        ptzConfig &&
        !isPtzControlZoomOnly &&
        isMovePTZAllowed &&
        isExternalPtz &&
        ptzConfig?.external?.externalType?.toLowerCase() === 'avigilon'
      "
      class="ptzInstructions"
      [matTooltip]="'cameras.ptz.hoverCenterCrosshair' | t"
      matTooltipPosition="above"
      size="md"
    >
      control_point
    </sn-icon>
    <sn-icon-button
      *ngIf="
        ptzConfig.vendorApis?.cloud?.ptz?.ptzAutotrackSet &&
        !isPtzControlZoomOnly &&
        isMovePTZAllowed
      "
      (click)="toggleAutotrack(true)"
      [matTooltip]="'cameras.ptz.enableAutotrack' | t"
      matTooltipPosition="above"
    >
      <sn-icon size="md">gps_fixed</sn-icon>
    </sn-icon-button>
    <sn-icon-button
      *ngIf="
        ptzConfig.vendorApis?.cloud?.ptz?.ptzAutotrackRemove &&
        !isPtzControlZoomOnly &&
        isMovePTZAllowed
      "
      (click)="toggleAutotrack(false)"
      [matTooltip]="'cameras.ptz.disableAutotrack' | t"
      matTooltipPosition="above"
    >
      <sn-icon size="md">gps_off</sn-icon>
    </sn-icon-button>
    <sn-icon-button
      *ngIf="
        ptzConfig.vendorApis?.cloud?.ptz?.ptzFocusSet && !isPtzControlZoomOnly && isMovePTZAllowed
      "
      (click)="ptzFocusSet()"
      [matTooltip]="'cameras.ptz.refocus' | t"
      matTooltipPosition="above"
    >
      <sn-icon size="md">center_focus_strong</sn-icon>
    </sn-icon-button>
    <sn-icon-button
      *ngIf="ptzConfig.vendorApis?.cloud?.ptz?.ptzBacklightSet"
      (click)="ptzBacklightSet()"
      [matTooltip]="'cameras.ptz.turnOnBacklight' | t"
      matTooltipPosition="above"
    >
      <sn-icon size="md">flashlight_on</sn-icon>
    </sn-icon-button>
    <sn-icon-button
      *ngIf="ptzConfig.vendorApis?.cloud?.ptz?.ptzBacklightRemove"
      (click)="ptzBacklightRemove()"
  [matTooltip]="'cameras.ptz.turnOffBacklight' | t"
      matTooltipPosition="above"
    >
      <sn-icon size="md">flashlight_off</sn-icon>
    </sn-icon-button>

    <sn-icon-button
      *ngIf="
        ptzConfig.vendorApis?.cloud?.ptz?.ptzHomeMove && !isPtzControlZoomOnly && isMovePTZAllowed
      "
      (click)="moveToHome()"
      [matTooltip]="'cameras.ptz.moveToHome' | t"
      matTooltipPosition="above"
    >
      <sn-icon>camera_indoor</sn-icon>
    </sn-icon-button>
    <sn-icon-button
      class="home-button"
      *ngIf="
        ptzConfig.vendorApis?.cloud?.ptz?.ptzHomeSet &&
        !isPtzControlZoomOnly &&
        isMovePTZAllowed &&
        !isExternalPtz &&
        ptzConfig?.external?.externalType?.toLowerCase() !== 'avigilon' &&
        canChangePresets
      "
      (click)="ptzHomeSet()"
      [matTooltip]="'cameras.ptz.setCurrentPositionAsHome' | t"
      matTooltipPosition="above"
    >
      <sn-icon size="md" fontSet="far" fontIcon="fa-clinic-medical"></sn-icon>
    </sn-icon-button>
    <sn-icon-button
      *ngIf="!isPtzControlZoomOnly && isMovePTZAllowed"
      [isLoading]="isLoadingArrowKeyControl"
      [color]="ptzConfig?.ptzControlEnableArrows ? 'accent' : null"
      [matTooltip]="(ptzConfig?.ptzControlEnableArrows ? 'cameras.ptz.toggleArrowKeyControlsOff' : 'cameras.ptz.toggleArrowKeyControlsOn') | t"
      matTooltipPosition="above"
      (click)="toggleArrowKeys()"
    >
      <sn-icon size="md" fontSet="far" fontIcon="fa-arrows-up-down-left-right"></sn-icon>
    </sn-icon-button>
    <sn-icon-button
      *ngIf="!isPtzControlZoomOnly && isMovePTZAllowed"
      [matMenuTriggerFor]="controlSettings"
      [matTooltip]="'cameras.ptz.controlSettings' | t"
      matTooltipPosition="above"
    >
      <sn-icon size="md" fontSet="far" fontIcon="fa-gears"></sn-icon>
    </sn-icon-button>
    <mat-menu
      yPosition="above"
      class="controlsSettingsMenu"
      #controlSettings="matMenu"
      (click)="$event.stopPropagation()"
    >
      <div class="toggleWrapper">
        <sn-slide-toggle
          [checked]="ptzConfig.ptzControlInvertX"
          [disabled]="isLoadingSetting.includes('ptzControlInvertX')"
          (click)="$event.stopPropagation()"
          (toggleChange)="onControlSettingChange($event, 'ptzControlInvertX')"
        >
          {{ 'cameras.invertXAxis' | t }}
        </sn-slide-toggle>
        <mat-spinner
          *ngIf="isLoadingSetting.includes('ptzControlInvertX')"
          color="accent"
          mode="indeterminate"
          diameter="24"
        ></mat-spinner>
      </div>
      <div class="toggleWrapper">
        <sn-slide-toggle
          [checked]="ptzConfig.ptzControlInvertY"
          [disabled]="isLoadingSetting.includes('ptzControlInvertY')"
          (click)="$event.stopPropagation()"
          (toggleChange)="onControlSettingChange($event, 'ptzControlInvertY')"
        >
          {{ 'cameras.invertYAxis' | t }}
        </sn-slide-toggle>
        <mat-spinner
          *ngIf="isLoadingSetting.includes('ptzControlInvertY')"
          color="accent"
          mode="indeterminate"
          diameter="24"
        ></mat-spinner>
      </div>
    </mat-menu>
  </div>
  <ng-content></ng-content>
</div>
